<template>
  <div class="offer-content-triple">
    <!-- Description Text (Top Center) -->
    <div
      class="offer-description"
      :style="descriptionStyle"
      v-html="formattedDescription"
    ></div>

    <!-- First Package (Left) -->
    <div v-if="firstPackage" class="package-container package-first">
      <!-- More Content Badge -->
      <OfferMoreContent
        :package="firstPackage"
        :display-config="firstPackageDisplayConfig"
        :offer-display-config="displayConfig"
        :custom-style="firstMoreContentStyle"
      />

      <!-- Old Price Badge -->
      <OfferOriginalPrice
        :package="firstPackage"
        :display-config="firstPackageDisplayConfig"
        :custom-style="firstOriginalPriceStyle"
      />

      <!-- Package Assets Display -->
      <OfferPackageAssets
        :package="firstPackage"
        :custom-style="firstAssetsStyle"
      />

      <!-- CTA Button -->
      <button class="offer-cta-button" @click="handlePurchase(firstPackage)">
        {{ getCtaButtonText(firstPackage) }}
      </button>
    </div>

    <!-- Second Package (Center) -->
    <div v-if="secondPackage" class="package-container package-second">
      <!-- More Content Badge -->
      <OfferMoreContent
        :package="secondPackage"
        :display-config="secondPackageDisplayConfig"
        :offer-display-config="displayConfig"
        :custom-style="secondMoreContentStyle"
      />

      <!-- Old Price Badge -->
      <OfferOriginalPrice
        :package="secondPackage"
        :display-config="secondPackageDisplayConfig"
        :custom-style="secondOriginalPriceStyle"
      />

      <!-- Package Assets Display -->
      <OfferPackageAssets
        :package="secondPackage"
        :custom-style="secondAssetsStyle"
      />

      <!-- CTA Button -->
      <button class="offer-cta-button" @click="handlePurchase(secondPackage)">
        {{ getCtaButtonText(secondPackage) }}
      </button>
    </div>

    <!-- Third Package (Right) -->
    <div v-if="thirdPackage" class="package-container package-third">
      <!-- More Content Badge -->
      <OfferMoreContent
        :package="thirdPackage"
        :display-config="thirdPackageDisplayConfig"
        :offer-display-config="displayConfig"
        :custom-style="thirdMoreContentStyle"
      />

      <!-- Old Price Badge -->
      <OfferOriginalPrice
        :package="thirdPackage"
        :display-config="thirdPackageDisplayConfig"
        :custom-style="thirdOriginalPriceStyle"
      />

      <!-- Package Assets Display -->
      <OfferPackageAssets
        :package="thirdPackage"
        :custom-style="thirdAssetsStyle"
      />

      <!-- CTA Button -->
      <button class="offer-cta-button" @click="handlePurchase(thirdPackage)">
        {{ getCtaButtonText(thirdPackage) }}
      </button>
    </div>
  </div>
</template>

<script>
import { offerMethodsMixin } from "./offerMethodsMixin";
import OfferMoreContent from "./offer-more-content.vue";
import OfferOriginalPrice from "./offer-original-price.vue";
import OfferPackageAssets from "./offer-package-assets.vue";

export default {
  name: "OfferLayoutTriple",
  components: {
    OfferMoreContent,
    OfferOriginalPrice,
    OfferPackageAssets,
  },
  mixins: [offerMethodsMixin],
  props: {
    offer: {
      type: Object,
      required: true,
    },
    displayConfig: {
      type: Object,
      default: null,
    },
    formattedDescription: {
      type: String,
      default: "",
    },
    descriptionStyle: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    firstPackage() {
      return this.offer?.packages?.[0] || null;
    },
    secondPackage() {
      return this.offer?.packages?.[1] || null;
    },
    thirdPackage() {
      return this.offer?.packages?.[2] || null;
    },
    firstPackageDisplayConfig() {
      if (!this.firstPackage?.display_config) return null;
      try {
        return typeof this.firstPackage.display_config === "string"
          ? JSON.parse(this.firstPackage.display_config)
          : this.firstPackage.display_config;
      } catch (e) {
        console.error("Error parsing first package display_config:", e);
        return null;
      }
    },
    secondPackageDisplayConfig() {
      if (!this.secondPackage?.display_config) return null;
      try {
        return typeof this.secondPackage.display_config === "string"
          ? JSON.parse(this.secondPackage.display_config)
          : this.secondPackage.display_config;
      } catch (e) {
        console.error("Error parsing second package display_config:", e);
        return null;
      }
    },
    thirdPackageDisplayConfig() {
      if (!this.thirdPackage?.display_config) return null;
      try {
        return typeof this.thirdPackage.display_config === "string"
          ? JSON.parse(this.thirdPackage.display_config)
          : this.thirdPackage.display_config;
      } catch (e) {
        console.error("Error parsing third package display_config:", e);
        return null;
      }
    },
    // First Package (Left) - Smallest (60%)
    firstMoreContentStyle() {
      return {
        top: "335px",
        left: "568px",
        width: "80px",
        height: "80px",
        padding: "15px",
        fontSize: "16px",
      };
    },
    firstOriginalPriceStyle() {
      return {
        width: "70px",
        height: "30px",
        top: "598px",
        left: "547px",
        padding: "4px",
        fontSize: "20px",
        lineHeight: "20px",
      };
    },
    firstAssetsStyle() {
      return {
        top: "364px",
        left: "320px",
        height: "209px",
        width: "297px",
      };
    },
    // Second Package (Center) - BIGGEST (100%)
    secondMoreContentStyle() {
      return {
        top: "252px",
        left: "946px",
        width: "130px",
        height: "130px",
        padding: "18px",
        fontSize: "18px",
      };
    },
    secondOriginalPriceStyle() {
      return {
        width: "99px",
        height: "38px",
        top: "577px",
        left: "983px",
        padding: "6px 14px",
        fontSize: "24px",
        lineHeight: "24px",
      };
    },
    secondAssetsStyle() {
      return {
        top: "285px",
        left: "678px",
        height: "286px",
        width: "341px",
      };
    },
    // Third Package (Right) - Mid-sized (80%)
    thirdMoreContentStyle() {
      return {
        top: "278px",
        right: "268px",
        width: "110px",
        height: "110px",
        padding: "20px",
        fontSize: "20px",
      };
    },
    thirdOriginalPriceStyle() {
      return {
        width: "86px",
        height: "35px",
        top: "589px",
        left: "1333px",
        padding: "8px",
        fontSize: "20px",
        lineHeight: "20px",
      };
    },
    thirdAssetsStyle() {
      return {
        top: "312px",
        left: "1087px",
        height: "261px",
        width: "298px",
      };
    },
  },
};
</script>

<style scoped lang="scss">
@import "./offer-shared-styles";

// Layout-specific positioning and sizing for triple package layout

.offer-description {
  left: 700px;
  top: 100px;
  width: 480px;
  height: 130px;
  line-height: 1.1;
}

.package-container {
  position: relative;
}

// First Package (Left) - Smallest (60% of base size)
.package-first {
  .offer-cta-button {
    left: 357px;
    top: 611px;
    width: 226px;
    height: 80px;
    font-size: 22px;
    line-height: 22px;
  }

  // More content badge text sizing
  ::v-deep .offer-more-content {
    .more-content-number {
      font-size: 24px;
    }

    .more-content-text {
      font-size: 10px;
      margin-top: 3px;
    }
  }

  // Original price strikethrough thickness
  ::v-deep .offer-original-price::after {
    height: 3px;
  }

  // Asset sizing
  ::v-deep .offer-assets {
    .asset-row-other {
      gap: 8px;
    }

    .asset-item-main {
      .asset-icon {
        width: 84px;
        height: 84px;
      }

      .asset-amount {
        font-size: 25.2px;
      }
    }

    .asset-item-other {
      .asset-icon {
        width: 42px;
        height: 42px;
      }

      .asset-amount {
        font-size: 13.2px;
      }
    }
  }
}

// Second Package (Center) - BIGGEST (100% base size)
.package-second {
  .offer-cta-button {
    left: 680px;
    top: 595px;
    width: 338px;
    height: 115px;
    border-radius: 60px;
    font-size: 34px;
    line-height: 34px;
  }

  // More content badge text sizing
  ::v-deep .offer-more-content {
    .more-content-number {
      font-size: 36px;
    }

    .more-content-text {
      font-size: 18px;
      margin-top: 4px;
    }
  }

  // Asset sizing
  ::v-deep .offer-assets {
    .asset-row-other {
      gap: 9px;
    }

    .asset-item-main {
      .asset-icon {
        width: 140px;
        height: 140px;
      }

      .asset-amount {
        font-size: 42px;
      }
    }

    .asset-item-other {
      .asset-icon {
        width: 70px;
        height: 70px;
      }

      .asset-amount {
        font-size: 22px;
      }
    }
  }
}

// Third Package (Right) - Mid-sized (80% of base size)
.package-third {
  .offer-cta-button {
    left: 1102px;
    top: 607px;
    width: 267px;
    height: 90px;
    font-size: 26px;
    line-height: 26px;
  }

  // More content badge text sizing
  ::v-deep .offer-more-content {
    .more-content-number {
      font-size: 30px;
    }

    .more-content-text {
      font-size: 16px;
      margin-top: 5px;
    }
  }

  // Asset sizing
  ::v-deep .offer-assets {
    .asset-row-other {
      gap: 10px;
    }

    .asset-item-main {
      .asset-icon {
        width: 112px;
        height: 112px;
      }

      .asset-amount {
        font-size: 33.6px;
      }
    }

    .asset-item-other {
      .asset-icon {
        width: 56px;
        height: 56px;
      }

      .asset-amount {
        font-size: 17.6px;
      }
    }
  }
}
</style>
